<template>
  <div class="colapsables">
    <div class="edicion_block">
      <div class="navcola_container">
        <div class="navcola delete-padding" style="border:0px !important;">
          <Icon icon="ph:paint-brush-broad-duotone" :style="{ fontSize: '30px', width:'20% !important' }" />
          <h4>{{ $t('style.generales.fondo') }}</h4>
        </div>
        <div class="contenido">
          <div class="row form_row">
            <div class="col-lg-6">
              <colorPicker
                :label="$t('pickers.colorfondo')"
                :color="fondo.background"
                :value="fondo.background"
                @input="updateFondoKey({ key: 'background', value: $event.hex ? $event.hex : $event })"
              />
            </div>
            <div class="col-lg-6">
              <opacityPicker :value="fondo.opacity" @input="updateFondoKey({ key: 'opacity', value: $event })" />
            </div>
            <div class="col-lg-6">
              <label>{{ $t('general.bckimage') }}</label>
              <switchPicker :value="fondo.active" @input="updateFondoKey({ key: 'active', value: $event })" />
            </div>
            <div class="col-lg-6">
              <label>{{ $t('general.fullwidth') }}</label>
              <switchPicker :value="fondo.fullwidth" @input="updateFondoKey({ key: 'fullwidth', value: $event })" />
            </div>
          </div>
          <div class="row form_row">
            <div class="col-lg-12 fondo-img-buttons">
              <imagePicker
                imgid="background"
                :btext="$t('pickers.loadi')"
                :value="fondo.img"
                @input="updateFondoKey({ key: 'img', value: $event })"
              />
            </div>
          </div>
          <div class="row form_row">
            <div class="col-lg-10">
              <videoEmbedPicker
                :value="fondo.videoUrl"
                @input="val => updateFondoKey({ key: 'videoUrl', value: val })"
                @video-selected="handleVideoSelection"
              />
            </div>
          </div>
          <div v-if="!fondo.fullwidth" class="row form_row mt20">
            <div class="col-lg-6">
              <switchPicker
                :value="fondo.animacion"
                @input="updateFondoKey({ key: 'animacion', value: $event })"
                :label="$t('pickers.movement')"
              />
            </div>
            <div class="col-lg-6">
              <sizePicker
                :value="fondo.width"
                @input="updateFondoKey({ key: 'width', value: $event })"
                :min="50"
                :max="1200"
                :interval="50"
              />
            </div>
            <div class="col-lg-6">
              <sizePicker
                :label="$t('pickers.hori')"
                :value="fondo.left"
                @input="updateFondoKey({ key: 'left', value: $event })"
                :min="-200"
                :max="200"
                :interval="10"
                unit="%"
              />
            </div>
            <div class="col-lg-6">
              <sizePicker
                :label="$t('pickers.verti')"
                :value="fondo.top"
                @input="updateFondoKey({ key: 'top', value: $event })"
                :min="-100"
                :max="200"
                :interval="10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colorPicker from '@/layouts/main_Customizer/dinputs/colorPicker'
import sizePicker from '@/layouts/main_Customizer/dinputs/sizePicker'
import opacityPicker from '@/layouts/main_Customizer/dinputs/opacityPicker'
import imagePicker from '@/components/imagePicker.vue'
import switchPicker from '@/layouts/main_Customizer/dinputs/switchPicker'
import videoEmbedPicker from '@/layouts/main_Customizer/dinputs/videoEmbededPicker.vue'
import { Icon } from '@iconify/vue2'
import useBackgroundEditor from '@features/editor/background/useBackgroundEditor'

export default {
  mixins: [useBackgroundEditor],
  components: {
    colorPicker,
    sizePicker,
    opacityPicker,
    imagePicker,
    switchPicker,
    videoEmbedPicker,
    Icon,
  },
}
</script>

<style scoped>
/* Aprovechar mas ancho util dentro de la columna: menos padding lateral
   en la tarjeta blanca del modulo Fondo (admin.css la deja en 12px con !important). */
.colapsables .navcola_container {
  padding: 12px 8px !important;
}

/* Mas aire entre el header (icono brocheta + "Fondo") y los campos. */
.colapsables .navcola.delete-padding {
  margin-bottom: 18px;
}

/* Espaciado interno: mas aire entre filas y entre campos. */
.colapsables .contenido .form_row {
  margin-top: 0;
  margin-bottom: 16px;
}
.colapsables .contenido .form_row:last-child {
  margin-bottom: 0;
}
.colapsables .contenido .form_row > [class^="col-"],
.colapsables .contenido .form_row > [class*=" col-"] {
  margin-bottom: 12px;
}
/* Las labels de los switches (Imagen de fondo / Todo el ancho) con aire. */
.colapsables .contenido .form_row label {
  display: block;
  margin-bottom: 6px;
}
</style>

<style>
/* Botones "Cambiar imagen" y "Editar" (del componente hijo imagePicker) uno al
   lado del otro. No-scoped para alcanzar el .form-group del hijo; la clase
   .fondo-img-buttons es exclusiva de este modulo, asi que no filtra a otros. */
.fondo-img-buttons .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
}
.fondo-img-buttons .form-group .btn {
  width: auto !important;
  margin: 0 !important;
}
</style>
